import React from 'react';
import { Router, Route, Switch, Link, NavLink } from 'react-router-dom';
import Loadable from 'react-loadable';
import createHistory from 'history/createBrowserHistory';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import './../AppRouter.scss';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = Loadable({
  loader: () => import('./../components/DefaultLayout'),
  loading
});

// Pages
const Login = Loadable({
  loader: () => import('./../views/Pages/Login'),
  loading
});

const Register = Loadable({
  loader: () => import('./../views/Pages/Register'),
  loading
});

const Page404 = Loadable({
  loader: () => import('./../views/Pages/Page404'),
  loading
});

const Page500 = Loadable({
  loader: () => import('./../views/Pages/Page500'),
  loading
});

const Users = Loadable({
  loader: () => import('../components/Timeline'),
  loading
});


export const history = createHistory();

const AppRouter = () => (
  <Router history={history}>
    <div>
      <Switch>
        <PublicRoute path="/" component={Login} exact={true} />
        <PrivateRoute path="/*" component={DefaultLayout} />
        {/*<PrivateRoute exact path="/dashboard" component={DefaultLayout} />
        <PrivateRoute exact path="/liveview" component={DefaultLayout} />
        <PrivateRoute exact path="/my_vehicles" component={DefaultLayout} />
        <PrivateRoute exact path="/parking" component={DefaultLayout} />
        <PrivateRoute exact path="/livevideo" component={DefaultLayout} />*/}
        <Route exact component={Page404} />
      </Switch>
    </div>
  </Router>
);

export default AppRouter;
